{
  "holdingAreaListItem": {
    "imageAlt": "N/A",
    "tenantTypes": {
      "transient": "Transient",
      "base": "Base",
      "yellowCard": "Base + Yellow Card"
    },
    "unknownModel": "Unknown Model",
    "buttons": {
      "assign": "Assign",
      "edit": "Edit",
      "remove": "Remove"
    },
    "confirmDialog": {
      "title": "Remove Aircraft from Holding Area?",
      "text": "Are you sure you want to remove {{identifier}} from the holding area?",
      "okButton": "Remove",
      "cancelButton": "Cancel"
    }
  },
  "assignAircraftDialog": {
    "title": "Assign Aircraft to Location",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Ramps"
    },
    "messages": {
      "mayBeTooSmall": "May be too small",
      "noLocations": "No hangars or ramps available"
    },
    "buttons": {
      "cancel": "Cancel",
      "assign": "Assign",
      "assigning": "Assigning..."
    }
  },
  "holdingAreaPresenter": {
    "title": "Holding Area"
  },
  "holdingAreaList": {
    "title": "Holding Area ({{count}})",
    "emptyState": "No aircraft in holding area"
  },
  "printLayout": {
    "hangarCount": "{{count}} Hangar",
    "sqft": " ft²",
    "aircraft": "Aircraft",
    "utilization": "Utilization"
  },
  "multiHangarInfoCard": {
    "title": "Multi-Hangar Summary",
    "labels": {
      "aircraft": "Aircraft",
      "utilization": "Utilization",
      "totalSqft": "Total Sqft",
      "totalUtilized": "Total Utilized",
      "estValue": "Est. Value",
      "total": "Total",
      "transients": "Transients",
      "estTowTime": "Est. Tow Time"
    },
    "tooltips": {
      "numberOfHangars": "Number of selected hangars",
      "aircraftCount": "Aircraft inside hangars / Total aircraft in selected hangars",
      "utilization": "Combined utilization across all selected hangars",
      "totalSqft": "Total hangar floor area across all selected hangars",
      "totalUtilized": "Total floor area occupied by aircraft",
      "estValue": "Estimated combined value of all hangars per day",
      "transientValue": "Revenue from overnight transient aircraft.",
      "estTowTime": "Total estimated tow time across all hangars"
    }
  }
}
